import styled from "styled-components";

const Heading = styled.div`
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-style: normal;
  font-weight: ${(props) => (props.light ? 100 : "normal")};
  font-size: 1.25rem;
  line-height: 130%;
  width: 100%;
  color: ${({ theme }) => theme.black};
  text-align: ${(props) => (props.squeeze ? "center" : null)};
  width: ${(props) => (props.squeeze ? "40%" : null)};
  @media (max-width: 768px) {
    font-size: 12px;
    width: 80%;
  }
`;

function P({ children, squeeze, light, onClick, ...rest }) {
  // forward any extra props (className, style, id, data-*, etc.) to the styled wrapper
  return (
    <Heading
      {...rest}
      onClick={onClick ? onClick : null}
      squeeze={squeeze}
      light={light}
    >
      {children}
    </Heading>
  );
}

export default P;
